import { Button, Card, Form, Image, Input, message, Modal, Select, Space, Spin } from "antd";
import React, { useEffect, useState } from "react";
import ticketNo from "../../../../assets/images/TicketNo.png";
import { UserEventService } from "../../../../api/user.service";
import { useId24 } from "../../../../drivers/id24/Id24Provider";
import { useParams } from "react-router-dom";
import Title from "antd/es/typography/Title";
import { MasterDataEventService } from "../../../../api/master-data-event.service";
import { LockOutlined } from "@ant-design/icons";
import { AgendesService } from "../../services/agendes-service";
import { loadAppConfig } from "../../../../configs/app-config";
import { Activityservice } from "../../../activity-list/services/importfile.service";

export const EconnectStepCheckin: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { agendaid, ticketid } = useParams<{ agendaid: string; ticketid: string }>();
  const [formValue] = Form.useForm();
  const [formPassword] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(true);
  const [userData, setUserDate] = useState<{
    userId: "";
    numberId: string;
    dataSource: {
      fullname: string;
      position: string;
      company: string;
      businessEmail: string;
      phoneNumber: string;
      businessType: {
        value: string;
        label: string;
      };
      type: string;
      ticketNumber: string;
    };
  }>({
    userId: "",
    numberId: "",
    dataSource: {
      fullname: "",
      position: "",
      company: "",
      businessEmail: "",
      phoneNumber: "",
      businessType: {
        value: "",
        label: "",
      },
      type: "",
      ticketNumber: "",
    },
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [wristbandId, setWristbandId] = useState<string>("");
  const [masterDataEvent, setMasterDataEvent] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    if (loading) {
      featchData();
    }
  }, [loading]);

  const featchData = async () => {
    try {
      if (agendaid && ticketid) {
        const resMasterDataEvent = await MasterDataEventService(apiBaseUrl).getByEventId(agendaid);
        setMasterDataEvent(resMasterDataEvent.dataSource);
        const user = await UserEventService(apiBaseUrl).getByEventAndTicket(agendaid, ticketid);
        formValue.setFieldValue("fullName", user.dataSource.fullname);
        formValue.setFieldValue("position", user.dataSource.position);
        formValue.setFieldValue("company", user.dataSource.company.label);
        formValue.setFieldValue("businessEmail", user.dataSource.businessEmail);
        formValue.setFieldValue("phoneNumber", user.dataSource.phoneNumber);
        formValue.setFieldValue("wristbandId", user.dataSource.wristbandId);
        formValue.setFieldValue("type", user.dataSource.type);
        setWristbandId(user.dataSource.wristbandId);
        setUserDate(user);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  const validateFormat = (value: string) => {
    const regex = /^(A|B|V)-(\d{4})$/;
    const match = value.match(regex);

    if (!match) return false;

    const [, , num] = match;
    const numInt = parseInt(num, 10);

    return numInt >= 1 && numInt <= 200;
  };

  const onValidateWristbandId = async (wristbandId: string): Promise<string | undefined> =>
    agendaid && UserEventService(apiBaseUrl).validateWristbandId(agendaid, wristbandId);

  const onSetWristband = async (value: any) => {
    const data = { ...userData.dataSource, wristbandId: formValue.getFieldValue("wristbandId") };
    try {
      if (agendaid) {
        await Activityservice(apiBaseUrl).checkIn(userData.userId);
        await UserEventService(apiBaseUrl).updateByEvent(userData.userId, data);
        message.success("success");
        setLoading(true);
        setIsModalOpen(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onValidatePassword = async (password: string): Promise<string | undefined> =>
    agendaid && AgendesService(apiBaseUrl).validatePassword(agendaid, password);

  return (
    <Spin tip="Loading..." spinning={loading}>
      <div className="w-[353px] h-[653.18px] top-[99px] left-[25px] rounded-[10px] pt-[32px] pr-[26px] pb-[32px] pl-[26px] gap-[32px]">
        <div className=" flex justify-center">
          <Image src={ticketNo} preview={false} />
        </div>
        <br />
        <div className=" flex justify-center">
          <Title level={4}>{userData.dataSource.ticketNumber}</Title>
        </div>
        <br />
        <Card>
          <Form form={formValue} layout="vertical" autoComplete="off" className="w-full" name="dataForm" onFinish={() => setIsModalOpen(true)}>
            <Form.Item className=" m-1" label={"Name-Surname"} name={"fullName"}>
              <Input disabled />
            </Form.Item>
            <Form.Item className=" m-1" label={"Position"} name={"position"}>
              <Input placeholder="Text" disabled />
            </Form.Item>
            <Form.Item className=" m-1" label={"Company"} name={"company"}>
              <Input placeholder="Text" disabled />
            </Form.Item>
            <Form.Item className=" m-1" label={"Business Email"} name={"businessEmail"}>
              <Input placeholder="example@email.com" type="email" disabled />
            </Form.Item>
            <Form.Item className=" m-1" label={"Phone number"} name={"phoneNumber"}>
              <Input placeholder="0XX-XXX-XXXX" disabled />
            </Form.Item>
            <Form.Item className=" m-1" label={"Type"} name={"type"}>
              <Input placeholder="Text" disabled />
            </Form.Item>
            {/* <Form.Item className=" m-1" label={"Wristband ID"} name={"wristbandId"}>
              <Input placeholder="A-12345" value={wristbandId} onChange={(e) => setWristbandId(e.target.value)} />
            </Form.Item> */}
            <Form.Item
              className=" m-1"
              label={"Wristband ID"}
              name={"wristbandId"}
              rules={[
                { required: true, message: "Please input your Wristband ID!" },
                {
                  validator: async (_, value) => {
                    if (value) {
                      if (validateFormat(value)) {
                        const validationFailReason = await onValidateWristbandId(value);
                        if (validationFailReason) {
                          throw new Error(validationFailReason);
                        }
                      } else {
                        throw new Error("Wristband ID format not found!!");
                      }
                    }
                  },
                },
              ]}
            >
              <Input placeholder="Enter (e.g., A-0001 B-0001 C-0001)"  />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Set
              </Button>
            </Form.Item>
          </Form>
        </Card>
        <Modal title="Password" open={isModalOpen} footer={[]} onCancel={() => setIsModalOpen(false)}>
          <Form form={formPassword} name="horizontal_login" layout="inline" onFinish={onSetWristband}>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
                {
                  validator: async (_, value) => {
                    if (value) {
                      const validationFailReason = await onValidatePassword(value);
                      if (validationFailReason) {
                        throw new Error(validationFailReason);
                      }
                    }
                  },
                },
              ]}
            >
              <Input prefix={<LockOutlined />} type="password" placeholder="Password" />
            </Form.Item>
            <Button type="primary" htmlType="submit">
              Confrim
            </Button>
          </Form>
        </Modal>
      </div>
    </Spin>
  );
};
